var map = {
	"./add.svg": "c2a3",
	"./add_major.svg": "6db5",
	"./delete.svg": "59a1",
	"./delete_1.svg": "e544",
	"./delete_major.svg": "ca97",
	"./edit.svg": "aa46",
	"./edit_major.svg": "17c2",
	"./increase.svg": "722e",
	"./major.svg": "87e4",
	"./manage_user.svg": "437d",
	"./menu.svg": "bd3d",
	"./peoples.svg": "2f11",
	"./qq.svg": "1430",
	"./share.svg": "5306",
	"./sina.svg": "b3a8",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";